import type { BoxProps } from "@mui/material";
import { Box, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1),
  height: "58px",
  minWidth: "100%",
  borderRadius: theme.spacing(0.5),
  position: "sticky",
  top: 10,
  zIndex: 1000,
  backgroundColor: theme.palette.background.default,
  boxShadow: theme.shadows[2],
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  height: "42px",
  width: "327px",
  "& .MuiToggleButton-root": {
    flex: 1,
    border: "none",
    borderRadius: 0,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: "none",
    backgroundColor: theme.palette._components.appBar.defaultFill,
    position: "relative",
    "&:first-of-type": {
      borderTopLeftRadius: theme.spacing(0.5),
      borderBottomLeftRadius: theme.spacing(0.5),
    },
    "&:last-of-type": {
      borderTopRightRadius: theme.spacing(0.5),
      borderBottomRightRadius: theme.spacing(0.5),
    },
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.default,
      border: "none",
      borderRadius: theme.spacing(0.5),
      backdropFilter: "blur(6px)",
      boxShadow: `0 0 2px 0 ${theme.palette.primary.dark}`,
      zIndex: 1,
      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        borderRadius: theme.spacing(0.5),
        padding: "2px",
        background: `
          linear-gradient(90deg, color-mix(in srgb, ${theme.palette.primary.light} 96%, transparent) 0%, color-mix(in srgb, ${theme.palette.primary.main} 96%, transparent) 100%),
          radial-gradient(50% 50% at 50% 50%, color-mix(in srgb, ${theme.palette.primary.light} 20%, transparent) 0%, color-mix(in srgb, ${theme.palette.secondary.light} 20%, transparent) 100%)
        `,
        mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        maskComposite: "exclude",
        WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        pointerEvents: "none",
      },
      "&:hover": {
        backgroundColor: theme.palette.background.default,
        backdropFilter: "blur(6px)",
        boxShadow: `0 0 2px 0 ${theme.palette.primary.dark}`,
      },
    },
  },
}));

export const LogoContainer = styled(Box)<BoxProps<"a">>(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
}));
